<template>
   
    
       
  
 <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="/"><i class="fab fa-think-peaks"></i></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <div id="nav">
    <router-link to="/">Home</router-link> |
   
      <router-link to="/about">About</router-link>|  
      <router-link to="/testimonials">Testimonials</router-link> |
        
        <router-link to="/education">Education</router-link>|
     <router-link to="/contact">Contact</router-link>|   
     <router-link to="/projects">Projects</router-link>| 
     <router-link to="/skills">Skills</router-link>|  
      </div>
    </div>
  </div>
</nav>

</template>

<script>
export default {

}
</script>

<style scoped>

</style>